module.exports = __webpack_public_path__ + "static/2-1-e8a4c1d192e22333092fdb8120561610.png";